import React, { Component } from "react";
import "./maintenance-card.scss";

class MaintenanceCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
      showDropdown: false,
    };
    this.dropdownRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target) &&
      !event.target.closest(".three-dots-button")
    ) {
      this.setState({ showDropdown: false });
    }
  };

  handleCheckboxChange = () => {
    this.setState(
      (prevState) => ({ isChecked: !prevState.isChecked }),
      () => {
        this.props.onMarkAsRead(
          this.state.isChecked,
          this.props.id,
          this.props.date
        );
        setTimeout(() => {
          this.setState({ isChecked: false });
        }, 1500);
      }
    );
  };

  handleDelete = () => {
    this.props.onDelete(this.props.id);
    this.setState({ showDropdown: false });
  };

  handleEdit = () => {
    this.props.onEdit(this.props.id);
    this.setState({ showDropdown: false });
  };

  toggleDropdown = (e) => {
    e.stopPropagation();
    this.setState((prevState) => ({
      showDropdown: !prevState.showDropdown,
    }));
  };

  formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${month}/${day}/${year}`;
    return formattedDate;
  };

  renderDescriptionWithLinks = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.split(/(\n|https?:\/\/[^\s]+)/g).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "underline" }}
          >
            {part}
          </a>
        );
      }
      if (part === "\n") {
        return <br key={index} />;
      }
      return part;
    });
  };

  render() {
    const { title, description, status, date, id, isBuilderUploaded } =
      this.props;
    const { isChecked, showDropdown } = this.state;

    const statusClass = status.toLowerCase();
    return (
      <div
        className={`maintenance-card ${statusClass} d-flex justify-content-between align-items-start p-3 mb-3 rounded shadow-sm position-relative`}
      >
        <div className="d-flex">
          {status === "Closed" ? (
            <i
              class="fa fa-check-circle check-item-close"
              aria-hidden="true"
              style={{ fontSize: "20px" }}
            ></i>
          ) : (
            <input
              type="radio"
              checked={isChecked}
              onChange={this.handleCheckboxChange}
              className="me-3"
              disabled={status === "Closed"}
            />
          )}

          <div>
            <h5 className="mb-1">{title}</h5>
            <p className="mb-2 text-muted">
              {this.renderDescriptionWithLinks(description)}
            </p>
            <div className="d-flex align-items-center gap-2">
              <span className={`badge ${statusClass}`}>{status}</span>
              <span className="text-muted small">{this.formatDate(date)}</span>
            </div>
          </div>
        </div>
        {isBuilderUploaded || status === "Closed" || status === "Overdue" ? (
          ""
        ) : (
          <div
            className="custom-dropdown position-relative"
            ref={this.dropdownRef}
          >
            <button
              onClick={this.toggleDropdown}
              className="btn p-0 border-0 bg-transparent three-dots-button"
            >
              <i className="fa fa-ellipsis-v text-dark" aria-hidden="true"></i>
            </button>
            {showDropdown && !isBuilderUploaded && (
              <div className="dropdown-content">
                <button
                  className="dropdown-item edit-btn"
                  onClick={this.handleEdit}
                >
                  <i className="fa fa-pencil" aria-hidden="true"></i>Edit
                </button>
                <button
                  className="dropdown-item delete-btn"
                  onClick={this.handleDelete}
                >
                  <i className="fa fa-trash-o" aria-hidden="true"></i>Delete
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default MaintenanceCard;



// WEBPACK FOOTER //
// ./src/HomeOwners/Components/MaintenanceCard.js